




































import { Component, Vue, Watch } from 'vue-property-decorator';
import Notification from './Notification.vue';
import { notificationWebservice } from '@/webservices/notification';
import type { Notification as notificationModel } from '@/models/notification';
import { Action } from 'vuex-class';

@Component({
    name: 'NotificationsPage',
    components: {
        Notification,
    },
})
export default class NotificationsPage extends Vue {
    private loading = false;
    private notifications: notificationModel[] = [];
    private page = 1;
    private lastPage = 1;
    private unreadOnly = false;

    @Action('notifications/fetchCount') private fetchNotificationCount;

    private mounted() {
        this.load();
    }

    private load() {
        this.loading = true;
        notificationWebservice.load(this.page, this.unreadOnly).then((responseNotifications) => {
            const res: Notification[] = (responseNotifications &&
                responseNotifications.data &&
                responseNotifications.data.data) as [];

            this.notifications = this.notifications.concat(res as []);
            this.page = this.page + 1;
            this.lastPage = responseNotifications.data.last_page;
            this.loading = false;
        });
    }

    private markAllAsRead() {
        notificationWebservice.markAllAsRead().then((response) => {
            this.page = 1;
            this.notifications = [];
            this.load();
            this.fetchNotificationCount();
        });
    }

    @Watch('unreadOnly')
    private onChangeUnreadOnly() {
        this.page = 1;
        this.notifications = [];
        this.load();
    }
}
